export default __webpack_public_path__ + "static/Claudia-47c4d9031c702f0c54ad13119605c534a1e81f58189ecb31b2e24fd7649c19f4.svg";